import { render } from "./DrawIndex.vue?vue&type=template&id=45e64355"
import script from "./DrawIndex.vue?vue&type=script&lang=js"
export * from "./DrawIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__